export default "__VITE_ASSET__Dxh8jxI1__"